import { useState, useEffect } from "react";
import axios from "axios";
import Header from "../../components/admin/Header";
import { useNavigate } from "react-router-dom";
import ExcelDownload from "../../components/admin/ExcelDownload";
import Modal from "../../components/admin/Modal";

const AllApplications = () => {
    // const [loadingModal, setLoadingModal] = useState(false);
    const [loadingId, setLoadingId] = useState(null);

    const [selectedApplication, setSelectedApplication] = useState(null);
    const [showModal, setShowModal] = useState(false);


    const navigate = useNavigate();
    const [applications, setApplications] = useState([]);
    const [pagination, setPagination] = useState({});
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10); // Default per-page value
    const [tabData, setTabData] = useState({});
    const fetchApplications = async (pageNumber, perPageValue) => {
        setLoading(true);
        const token = localStorage.getItem("adminToken");
        // const token ='30|b4RvvENlnNxIEmTCb8Kol1xu4fShErhHrfMfJaA7459ca955';    
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/admin/all-applications?page=${pageNumber}&per_page=${perPageValue}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`, // Send the token as a Bearer token
                        "Content-Type": "application/json"
                    }
                }
            );


            const sortedApps = (response.data.data || []).sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
            setApplications(sortedApps);
            // console.log(response.data.data);
            setPagination(response.data.pagination || {}); // Handle "All" case where pagination is null
        } catch (error) {
            console.error("Error fetching applications:", error);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchApplications(page, perPage);
    }, [page, perPage]);

    const handleLogout = () => {
        localStorage.setItem("parentToken", "");
        alert("logging out")
        navigate("/")
    }


    const buttons = [
        {
            text: "Home",
            onClick: () => (window.location.href = "https://www.ssvkchokkady.org/"),
            color: "bg-blue-500 text-white"
        },
        {
            text: `${Array.isArray(tabData?.approved_applications) && tabData.approved_applications.length > 0
                ? "Apply for another Child"
                : "Apply"}`,
            route: "/basic-info",
            color: "bg-blue-500 text-white"
        },
        { text: "Logout", onClick: handleLogout, color: "bg-red-500 text-white" },
    ];

    const moredetails = async (url, id) => {
        setLoadingId(id); // Set the currently loading application
        try {
            const token = localStorage.getItem("adminToken");
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            const data = await response.json();
            if (data.success) {
                setSelectedApplication(data.data);
                setShowModal(true);
            } else {
                setSelectedApplication({ error: "Failed to fetch details." });
            }
        } catch (error) {
            setSelectedApplication({ error: "Error fetching details." });
        } finally {
            setLoadingId(null); // Clear loading state
        }
    };




    return (
        <div className="min-h-screen bg-gray-50">
            {/* <Header logo="../ssvk-logo.png" buttons={buttons} /> */}

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <div className="flex flex-col md:flex-row md:items-center justify-between mb-8">
                    <div>
                        <h2 className="text-3xl font-bold text-gray-800 tracking-tight">All Applications</h2>
                        <p className="text-sm text-gray-500 mt-1">Manage and view all student applications</p>
                    </div>

                    <div className="mt-4 md:mt-0 flex items-center space-x-4">
                        <div className="flex items-center space-x-2 bg-white px-3 py-2 rounded-lg border border-gray-200 shadow-sm">
                            <label className="text-sm font-medium text-gray-600">Show:</label>
                            <select
                                value={perPage}
                                onChange={(e) => {
                                    setPerPage(e.target.value);
                                    setPage(1); // Reset to first page when changing per_page
                                }}
                                className="bg-transparent text-sm font-semibold text-gray-800 focus:outline-none cursor-pointer"
                            >
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="100">100</option>
                                <option value="All">All</option>
                            </select>
                            <span className="text-sm text-gray-500">entries</span>
                        </div>

                        <div className="shadow-sm rounded-lg">
                            {/* Excel Download Button is assumed to render a button, wrapping it helps position it */}
                            <ExcelDownload data={applications} fileName="AllApplications" />
                        </div>
                    </div>
                </div>

                {loading ? (
                    <div className="flex justify-center items-center py-20">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                        <span className="ml-3 text-lg text-gray-600 font-medium">Loading applications...</span>
                    </div>
                ) : (
                    <>
                        <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
                            <div className="overflow-x-auto">
                                <table className="w-full text-left text-sm text-gray-700">
                                    <thead className="bg-gray-100 text-gray-600 uppercase text-xs tracking-wider border-b border-gray-200">
                                        <tr>
                                            <th className="px-6 py-4 font-semibold">Application No</th>
                                            <th className="px-6 py-4 font-semibold">First Name</th>
                                            <th className="px-6 py-4 font-semibold">Last Name</th>
                                            <th className="px-6 py-4 font-semibold">Status</th>
                                            <th className="px-6 py-4 font-semibold text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-100">
                                        {applications.length > 0 ? (
                                            applications.map((app) => (
                                                <tr key={app.id} className="hover:bg-blue-50 transition-colors duration-150 group">
                                                    <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                                        {app.application_no}
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap">{app.first_name}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap">{app.last_name}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap">
                                                        <span className={`px-3 py-1 rounded-full text-xs font-semibold
                                                            ${app.status?.toLowerCase() === 'approved' ? 'bg-green-100 text-green-700' :
                                                                app.status?.toLowerCase() === 'rejected' ? 'bg-red-100 text-red-700' :
                                                                    'bg-yellow-100 text-yellow-700'}`}>
                                                            {app.status}
                                                        </span>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-center">
                                                        <button
                                                            onClick={() => moredetails(app.detailsUrl, app.id)}
                                                            disabled={loadingId === app.id}
                                                            className="inline-flex items-center justify-center bg-white border border-blue-200 text-blue-600 hover:bg-blue-600 hover:text-white px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed group-hover:border-blue-300"
                                                        >
                                                            {loadingId === app.id ? (
                                                                <>
                                                                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                                                                    Loading...
                                                                </>
                                                            ) : 'View Details'}
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="px-6 py-12 text-center text-gray-500">
                                                    No applications found for the selected criteria.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Pagination Controls */}
                        {perPage !== "All" && pagination.total > perPage && (
                            <div className="flex items-center justify-between mt-6 bg-white px-4 py-3 rounded-xl shadow-sm border border-gray-200">
                                <div className="text-sm text-gray-600">
                                    Showing <span className="font-semibold text-gray-900">{(pagination.current_page - 1) * perPage + 1}</span> to <span className="font-semibold text-gray-900">{Math.min(pagination.current_page * perPage, pagination.total)}</span> of <span className="font-semibold text-gray-900">{pagination.total}</span> entries
                                </div>
                                <div className="flex space-x-2">
                                    <button
                                        onClick={() => setPage(page - 1)}
                                        disabled={pagination.current_page <= 1}
                                        className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                                    >
                                        Previous
                                    </button>
                                    <div className="flex items-center px-4 font-medium text-sm text-gray-700 bg-gray-50 rounded-lg border border-gray-200">
                                        Page {pagination.current_page} of {pagination.last_page}
                                    </div>
                                    <button
                                        onClick={() => setPage(page + 1)}
                                        disabled={pagination.current_page >= pagination.last_page}
                                        className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
            <Modal
                modalId={loadingId}
                loading={loadingId === 'modal1' && loading} // Check if this modal is loading
                show={showModal}
                onClose={() => setShowModal(false)}
                formData={selectedApplication}
            />

        </div>
    );
};

export default AllApplications;